import { getKeys, hasMissingSchemaVariables, siteIDs, } from '../../adapters/utils';
import { getMainImageUrl } from './calculated/get-main-image-url';
import { get } from '../../utils/get';
import { getRobots } from './calculated/get-robots';
import { shouldRenderSchema } from './structured-data/should-render-schema';
import { renderStructureData } from './structured-data/render-structured-data';
import { shorten } from '../../utils/shorten';
export var IDs = {
    AVAILABILITY: 'challenge.registration.availability',
    CALCULATED_MAIN_IMAGE_URL: 'challenge.mainImage.url',
    CALCULATED_ROBOTS: 'challenge.robots',
    CREATED_DATE: 'challenge.created',
    CURRENCY: 'challenge.registration.currency',
    DESCRIPTION: 'challenge.description',
    DESCRIPTION_150: 'challenge.description.150',
    IMAGE_HEIGHT: 'challenge.mainImage.height',
    IMAGE_ID: 'challenge.mainImage.id',
    IMAGE_WIDTH: 'challenge.mainImage.width',
    LAST_MODIFIED_DATE: 'challenge.lastMod',
    NAME: 'challenge.name',
    PRICE: 'challenge.registration.price',
    SD_DISABLE_SCHEMA: 'challenge.structured-data.disable-schema',
    SD_JSON_RENDER: 'challenge.structured-data.render',
    URL: 'challenge.url',
};
var userVisible = [];
var requiredSchemaVariables = [siteIDs.SITE_NAME, siteIDs.BUSINESS_NAME];
export default {
    IDs: IDs,
    requiredSchemaVariables: requiredSchemaVariables,
    getData: function (item) {
        var _a;
        var fullDescription = get(item, 'challenge.description');
        var data = (_a = {},
            _a[IDs.AVAILABILITY] = get(item, 'challenge.registration.availability'),
            _a[IDs.CALCULATED_MAIN_IMAGE_URL] = getMainImageUrl(item),
            _a[IDs.CALCULATED_ROBOTS] = getRobots(item),
            _a[IDs.CREATED_DATE] = get(item, 'challenge.created'),
            _a[IDs.CURRENCY] = get(item, 'challenge.registration.currency'),
            _a[IDs.DESCRIPTION] = fullDescription,
            _a[IDs.DESCRIPTION_150] = shorten(fullDescription, 150),
            _a[IDs.IMAGE_HEIGHT] = get(item, 'challenge.mainImage.height'),
            _a[IDs.IMAGE_ID] = get(item, 'challenge.mainImage.id'),
            _a[IDs.IMAGE_WIDTH] = get(item, 'challenge.mainImage.width'),
            _a[IDs.LAST_MODIFIED_DATE] = get(item, 'challenge.lastMod'),
            _a[IDs.NAME] = get(item, 'challenge.name'),
            _a[IDs.PRICE] = get(item, 'challenge.registration.price'),
            _a[IDs.URL] = get(item, 'challenge.url'),
            _a[IDs.SD_DISABLE_SCHEMA] = !shouldRenderSchema(item) ||
                hasMissingSchemaVariables(requiredSchemaVariables, item),
            _a);
        data[IDs.SD_JSON_RENDER] = renderStructureData(item, data, IDs);
        return data;
    },
    getLegacySeoBlob: function () { },
    getSlug: function () { return ''; },
    updateItemDataWithSlug: function (item) { return item; },
    getBiData: function (item) { return ({
        id: get(item, 'challenge.id'),
        name: get(item, 'challenge.name'),
    }); },
    getKeys: function () { return getKeys(IDs, userVisible); },
};
